import { o as t } from "./index839.mjs";
var e = t, n = TypeError, c = function(r, o) {
  if (e(o, r))
    return r;
  throw new n("Incorrect invocation");
};
export {
  c as a
};
